import langs from "./langs";
import animations from "../animations.json";

const langKeys = Object.keys(langs);

const fields = [
    {
        name: "region",
        required: true,
    },
    {
        name: "title",
        required: true,
    },
    {
        name: "subtitle",
        required: false,
    }
];

animations.items.forEach(item => {
    langKeys.forEach(lang => {
       if (typeof langs[lang][item.video] === "undefined") {
           console.warn(`Missing ${lang} translation for video ${item.video}`);
           return;
       }
       fields.forEach(field => {
           if(typeof langs[lang][item.video][field.name] === "undefined") {
               console.warn(`Missing ${lang} translation key ${field.name} for video ${item.video}`);
               return;
           }
           if(field.required && langs[lang][item.video][field.name] === "") {
               console.warn(`Empty ${lang} translation key ${field.name} for video ${item.video}`);
           }
           item[field.name][lang] = langs[lang][item.video][field.name];
       })
    });
});

export default animations;
